import { useEffect, useState } from 'react';
import {
  getDepotPendingCount,
  subscribeDepotPendingCount,
} from '../utils/depotPendingCountStore';
import {
  getPubGraphisteAFaireCount,
  subscribePubGraphisteAFaireCount,
} from '../utils/pubGraphisteCountStore';

/**
 * Compteurs « À traiter » déjà alimentés par MasterLayout (stores partagés).
 */
export default function useHomeActionCounts() {
  const [depotPending, setDepotPending] = useState(
    () => getDepotPendingCount() ?? 0,
  );
  const [pubGraphiste, setPubGraphiste] = useState(
    () => getPubGraphisteAFaireCount() ?? 0,
  );

  useEffect(() => {
    const unsubDepot = subscribeDepotPendingCount(setDepotPending);
    const unsubPub = subscribePubGraphisteAFaireCount(setPubGraphiste);
    return () => {
      unsubDepot();
      unsubPub();
    };
  }, []);

  return { depotPending, pubGraphiste };
}
